import axios from "axios";
import { apiURL } from "./config";




const getAuthKey = () =>{
  return "amt1QDhlYWtoUzlTOjhyUzBnU0coVDQwKTlDaA==";
}

const getSessionId = () =>{
  return "amt1QDhlYWtoU";
}

const fetchFromApiServer = (requestType, url, data, options) => {
    return fetchApiWrapper(getAuthKey(), url, requestType, data, options)
};

const fetchApiWrapper = (authKey, uri, requestType, data, options = {}) => {
   const url = apiURL() + uri;
   const axiosConfig = {
      headers: {
        'Content-Type': requestType === "MULTIPART" ?  'multipart/form-data' : 'application/json',
        // 'authorization': authKey
      },
      timeout: 15000,
      auth:{

      }
  };
  if(requestType === "GET"){
    return axios({url, method:'get', ...axiosConfig})
  }else if(requestType === "POST"){
    return axios({url, method:'post', data, ...axiosConfig})
  }else if(requestType === "MULTIPART"){
    return axios({url, method:'post', data, ...axiosConfig})
  }
};

export default fetchFromApiServer;
